<template>
  <div class="sub-gnb-back flex flex-space-between flex-align-center">
    <nuxt-img
      class="ml-16"
      src="/icons/outline/chevron-left.svg"
      height="24"
      width="24"
      alt="back"
      @click="routeBack"
    />
    <div class="title mr-40">
      {{ title }}
    </div>
    <slot />
    <div />
  </div>
</template>

<script setup lang="ts">
import { isNativeShellApp } from '@/utils/appBridgeGate'

const { navigate } = useCommon()
const { options, back } = useRouter()

const props = withDefaults(
  defineProps<{
    title?: string
    partnersKey?: string
    redirectRoot?: boolean
    backUrl?: string
    appCloseWebview?: boolean
  }>(),
  {
    title: '',
    partnersKey: '',
    redirectRoot: false,
    backUrl: '',
    appCloseWebview: false
  }
)

const routeBack = () => {
  // 2.2.7 이상: 히스토리 되감기 대신 웹뷰를 닫아 이전 네이티브 화면(마이 탭)으로 복귀.
  // 2.2.6 이하는 상주 웹뷰에 closeWebview 핸들러가 없어 호출이 무시되므로
  // 아래 히스토리 되감기로 떨어뜨린다.
  if (props.appCloseWebview && isNativeShellApp()) {
    window.flutter_inappwebview?.callHandler('closeWebview', { force: true })
    return
  }

  const backUrl = options.history.state.back

  if (props.backUrl) {
    navigateTo(props.backUrl)
    return
  }

  if (!backUrl) {
    navigate('/', props.partnersKey)
    return
  }

  const historyUrl = String(backUrl)

  if (
    historyUrl.includes('/user/refund/refund-success') ||
    historyUrl.includes('/user/login') ||
    historyUrl.includes('/insurance/purchase/callback')
  ) {
    navigate('/', props.partnersKey)
    return
  }

  back()
}
</script>
<style scoped lang="scss">
.sub-gnb-back {
  background-color: $base-white;
  height: 56px;
  width: 100%;
  max-width: 500px;
  .title {
    @include body3-semibold;
  }
}
</style>
